import { Plus, SlidersHorizontal } from 'lucide-react'

type ChatFloatingActionsProps = {
  dimmed: boolean
  onOpenSettings: () => void
  onNewChat: () => void
}

export function ChatFloatingActions({
  dimmed,
  onOpenSettings,
  onNewChat,
}: ChatFloatingActionsProps) {
  return (
    <div
      className="fixed right-3 z-[25] flex flex-col"
      style={{
        top: 'calc(var(--tg-safe-area-inset-top, 0px) + var(--tg-content-safe-area-inset-top, 0px) + 56px)',
        gap: '8px',
        opacity: dimmed ? 0.66 : 0.96,
      }}
    >
      <button
        onClick={onOpenSettings}
        className="rounded-xl glass-icon flex items-center justify-center active:scale-90 transition-transform"
        style={{ width: '38px', height: '38px' }}
        title="Настройки этого чата"
      >
        <SlidersHorizontal size={16} className="text-telegram-button" />
      </button>
      <button
        onClick={onNewChat}
        className="rounded-xl glass-icon flex items-center justify-center active:scale-90 transition-transform"
        style={{ width: '38px', height: '38px' }}
        title="Новый чат"
      >
        <Plus size={17} className="text-telegram-button" />
      </button>
    </div>
  )
}
